import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from '@/components/v4';
import { Box } from '@chakra-ui/react';

const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    catalogItemName,
    onConfirm,
    isDeleting,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Delete Catalog Item</ModalHeader>
                <ModalBody>
                    <Box>
                        Are you sure you want to delete the catalog item
                        {catalogItemName ? ` "${catalogItemName}"` : ''}?
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} mr={3}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="red"
                        onClick={onConfirm}
                        isLoading={isDeleting}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;
